export default {
	click_instance_to_browse_content: 'Klicken Sie auf eine Instanz, um deren Inhalte zu durchsuchen.',
	click_instance_to_see_results: 'Klicken Sie auf eine Instanz, um die Ergebnisse für diese Instanz anzuzeigen.',

	column_configurator_add_all: 'Alle hinzufügen',
	column_configurator_add_selected: 'Ausgewählte hinzufügen',
	column_configurator_available_columns: 'Verfügbare Spalten',
	column_configurator_cancel_button: 'Abbrechen',
	column_configurator_disabled_global_mode: 'Spalten-Konfiguration nicht verfügbar im globalen Modus',
	column_configurator_displayed_columns: 'Angezeigte Spalten',
	column_configurator_first_column: 'Erste Spalte',
	column_configurator_move_down: 'Nach unten',
	column_configurator_move_up: 'Nach oben',
	column_configurator_no_columns_hint: 'Wählen Sie Spalten aus der linken Liste aus',
	column_configurator_no_columns_selected: 'Keine Spalten ausgewählt',
	column_configurator_remove_all: 'Alle entfernen',
	column_configurator_remove_column: 'Spalte entfernen',
	column_configurator_remove_directly: 'Direkt entfernen',
	column_configurator_remove_selected: 'Ausgewählte entfernen',
	column_configurator_reset_button: 'Standard wiederherstellen',
	column_configurator_reset_confirm_cancel: 'Abbrechen',
	column_configurator_reset_confirm_message:
		'Möchten Sie die Spalten-Konfiguration wirklich auf die Standardwerte zurücksetzen?',
	column_configurator_reset_confirm_ok: 'Ja, zurücksetzen',
	column_configurator_reset_confirm_title: 'Standard wiederherstellen',
	column_configurator_save_button: 'Speichern',
	column_configurator_save_success: 'Spalten-Konfiguration gespeichert',
	column_configurator_search_placeholder: 'Spalten suchen...',
	column_configurator_selected_count: '{count} ausgewählt',
	column_configurator_subtitle:
		'Wählen Sie die anzuzeigenden Spalten aus und bestimmen Sie deren Reihenfolge durch Drag & Drop.',
	column_configurator_title: 'Spalten konfigurieren',

	global_search_exiting: 'Verlasse globalen Suchmodus...',
	global_search_loading: 'Globale Suche läuft...',
	global_search_results_available: 'Suchergebnisse verfügbar',
	global_search_searching_for: 'Suche in allen Akten nach "{searchTerm}"...',
	ido_add_ido_favorite: 'Favorit',
	ido_button_search_dialog_close: 'Schließen',
	ido_button_search_dialog_close_and_apply: 'Übernehmen',
	ido_button_search_empty_title: 'Suche starten',
	ido_button_search_minimum_input_label: 'Mindestens 3 Zeichen eingeben.',
	ido_button_search_no_display_field_value: 'Anzeigefeld ist Leer, bitte vervollständigen',
	ido_button_search_no_matches_label: 'Für diese Suche wurden keine passenden Akten gefunden.',
	ido_button_search_no_preview_label: 'Keine weiteren Vorschaudaten verfügbar',
	ido_button_search_no_results: 'Keine Ergebnisse',
	ido_button_search_no_results_title: 'Keine Treffer',
	ido_button_search_select_label: 'Digitale Akten zum verpuzzeln suchen',
	ido_button_unlink_label: 'Lösen',
	ido_calculation_no_data_hint: 'Keine numerischen Werte für die Kalkulation verfügbar.',
	ido_calculation_summary_scope_tooltip:
		'Σ / ∅ / Min / Max beziehen sich auf die komplette Liste, nicht nur auf die aktuelle Seite.',
	ido_calculation_toggle_disable_tooltip: 'Kalkulationszeile deaktivieren',
	ido_calculation_toggle_enable_tooltip: 'Kalkulationszeile aktivieren',
	ido_changelog_action_delete:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-neg">löschte</span> die <span class="ido-cl-value">Akte</span>',
	ido_changelog_action_deselect_multiple_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-neg">deaktivierte</span> im <span class="ido-cl-field">Mehrfachauswahlfeld {field}</span> den Wert <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_deselect_single_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">deselektierte</span> den Wert im <span class="ido-cl-field">Einzelauswahlfeld {field}</span>',
	ido_changelog_action_fix_next_contact:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">aktivierte</span> die <span class="ido-cl-field">Hervorhebung</span> des <span class="ido-cl-value">nächsten Kontakts</span>',
	ido_changelog_action_select_multiple_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">aktivierte</span> im <span class="ido-cl-field">Mehrfachauswahlfeld {field}</span> den Wert <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_select_single_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">selektierte</span> im <span class="ido-cl-field">Einzelauswahlfeld {field}</span> den Wert <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_archive:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">aktualisierte</span> das <span class="ido-cl-field">Archiv</span> mit dem Wert <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_contact_person:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">setzte</span> die <span class="ido-cl-field">Kontaktperson</span> auf <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_hint:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">aktualisierte</span> den <span class="ido-cl-field">Hinweis</span> mit dem Wert <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_last_contact_date:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">setzte</span> den <span class="ido-cl-field">letzten Kontakt</span> auf das Datum <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_next_contact_date:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">setzte</span> den <span class="ido-cl-field">nächsten Kontakt</span> auf das Datum <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_next_contact_time:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">setzte</span> die <span class="ido-cl-field">nächste Kontakt-Uhrzeit</span> auf <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_value:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">aktualisierte</span> das <span class="ido-cl-field">Eingabefeld {field}</span> mit dem Wert <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_unfix_next_contact:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-neg">entfernte</span> die <span class="ido-cl-field">Hervorhebung</span> des <span class="ido-cl-value">nächsten Kontakts</span>',
	ido_changelog_empty_title: 'Keine Versionen vorhanden',
	ido_changelog_field_archive: 'Archiv',
	ido_changelog_field_contact_person: 'Kontaktperson',
	ido_changelog_field_highlight: 'Hervorhebung',
	ido_changelog_field_hint: 'Hinweis',
	ido_changelog_field_last_contact: 'Letzter Kontakt',
	ido_changelog_field_next_contact: 'Nächster Kontakt',
	ido_changelog_field_next_contact_time: 'Kontakt-Uhrzeit',
	ido_changelog_load_error: 'Versionen konnten nicht geladen werden',
	ido_changelog_tab_label: 'Versionen',
	ido_context_menu_add_to_favorite: 'Zu den Favoriten hinzufügen',
	ido_context_menu_clone_ido: 'Akte kopieren in',
	ido_context_menu_create_task: 'Aufgabe anlegen',
	ido_context_menu_delay_one_day: 'Auf morgen',
	ido_context_menu_delay_one_week: 'In die nächste Woche',
	ido_context_menu_history: 'Historie',
	ido_context_menu_open_ido: 'Akte öffnen',
	ido_context_menu_relations_history: 'Beziehungshistorie',
	ido_context_menu_today: 'Heute',
	ido_copy: 'Kopieren',
	ido_copy_dialog_copy_ido: 'Akte kopieren',
	ido_copy_dialog_to_the_instance: 'In die Instanz',
	ido_create_dialog_create_new_ido: 'Neue Akte anlegen',
	ido_create_dialog_in_the_instance: 'In der Instanz',
	ido_create_document: 'Dokumente hochladen',
	ido_create_memo: 'Aktennotiz anlegen',
	ido_create_note: 'Merkzettel anlegen',
	ido_create_task: 'Aufgabe anlegen',
	ido_datefield_close: 'Schließen',
	ido_delete_dialog_confirm_cancel_label: 'Nein',
	ido_delete_dialog_confirm_message: 'Möchten Sie diese Akte wirklich löschen?',
	ido_delete_dialog_confirm_ok_label: 'Ja',
	ido_delete_dialog_confirm_title: 'Akte löschen',
	ido_delete_error_message: 'Die Akte konnte nicht gelöscht werden.',
	ido_delete_stale_message:
		'Die Akte wurde zwischenzeitlich geändert und nicht gelöscht. Die Ansicht wurde aktualisiert — bitte prüfen und erneut löschen.',
	ido_detail_unavailable_message:
		'Der Server hat für diese Verknüpfung keine Akten-Stammdaten geliefert. Die Verknüpfung bleibt bestehen, die Akte kann hier aber nicht angezeigt werden.',
	ido_detail_unavailable_title: 'Akte kann nicht angezeigt werden',
	ido_details_search_add_condition: 'Bedingung',
	ido_details_search_add_group: 'Gruppe',
	ido_details_search_autocomplete_hints_error: 'Die Suchvorschläge konnten nicht geladen werden.',
	ido_details_search_date_dynamic_operation_currentCalendarWeek: 'aktuelle Kalenderwoche',
	ido_details_search_date_dynamic_operation_currentMonth: 'aktueller Monat',
	ido_details_search_date_dynamic_operation_currentQuarter: 'aktuelles Quartal',
	ido_details_search_date_dynamic_operation_currentYear: 'aktuelles Jahr',
	ido_details_search_date_dynamic_operation_label: 'Datumsvariante',
	ido_details_search_date_dynamic_operation_monthOfCurrentYear: 'Monat des aktuellen Jahres',
	ido_details_search_date_dynamic_operation_nthDayOfCurrentMonth: 'Tag im aktuellen Monat',
	ido_details_search_date_dynamic_operation_nthWeekdayOfCurrentMonth: 'Wochentag im aktuellen Monat',
	ido_details_search_date_dynamic_operation_quarterOfCurrentYear: 'Quartal des aktuellen Jahres',
	ido_details_search_date_dynamic_operation_today: 'heute',
	ido_details_search_date_dynamic_operation_weekdayOfCurrentCalendarWeek: 'Wochentag der aktuellen Kalenderwoche',
	ido_details_search_date_from_label: 'Von',
	ido_details_search_date_interval_label: 'Anzahl',
	ido_details_search_date_month_april: 'April',
	ido_details_search_date_month_august: 'August',
	ido_details_search_date_month_december: 'Dezember',
	ido_details_search_date_month_february: 'Februar',
	ido_details_search_date_month_january: 'Januar',
	ido_details_search_date_month_july: 'Juli',
	ido_details_search_date_month_june: 'Juni',
	ido_details_search_date_month_label: 'Monat',
	ido_details_search_date_month_march: 'März',
	ido_details_search_date_month_may: 'Mai',
	ido_details_search_date_month_november: 'November',
	ido_details_search_date_month_october: 'Oktober',
	ido_details_search_date_month_september: 'September',
	ido_details_search_date_nth_day_label: 'Tagnummer',
	ido_details_search_date_nth_weekday_number_label: 'Woche im Monat',
	ido_details_search_date_quarter_label: 'Quartal',
	ido_details_search_date_quarter_q1: 'Q1',
	ido_details_search_date_quarter_q2: 'Q2',
	ido_details_search_date_quarter_q3: 'Q3',
	ido_details_search_date_quarter_q4: 'Q4',
	ido_details_search_date_range_label: 'Zeiteinheit',
	ido_details_search_date_relative_range_day: 'Tage',
	ido_details_search_date_relative_range_month: 'Monate',
	ido_details_search_date_relative_range_quarter: 'Quartale',
	ido_details_search_date_relative_range_week: 'Wochen',
	ido_details_search_date_relative_range_year: 'Jahre',
	ido_details_search_date_terms_unsupported: 'Diese Datumsvariante wird im nächsten Slice vervollständigt.',
	ido_details_search_date_to_label: 'Bis',
	ido_details_search_date_type_dynamic: 'dynamisch',
	ido_details_search_date_type_fixed: 'fest',
	ido_details_search_date_type_label: 'Datumstyp',
	ido_details_search_date_weekday_friday: 'Freitag',
	ido_details_search_date_weekday_label: 'Wochentag',
	ido_details_search_date_weekday_monday: 'Montag',
	ido_details_search_date_weekday_saturday: 'Samstag',
	ido_details_search_date_weekday_sunday: 'Sonntag',
	ido_details_search_date_weekday_thursday: 'Donnerstag',
	ido_details_search_date_weekday_tuesday: 'Dienstag',
	ido_details_search_date_weekday_wednesday: 'Mittwoch',
	ido_details_search_dialog_active_count: '{count} aktive Bedingungen',
	ido_details_search_dialog_apply: 'Anwenden',
	ido_details_search_dialog_cancel: 'Abbrechen',
	ido_details_search_dialog_dirty_hint: 'Es gibt nicht angewendete Änderungen in diesem Entwurf.',
	ido_details_search_dialog_draft_count: '{count} Bedingungen im Entwurf',
	ido_details_search_dialog_editor_pending_hint:
		'Die Feld- und Term-Editoren folgen im nächsten Slice. Bereits vorhandene Detailsuchen können hier schon geprüft und zurückgesetzt werden.',
	ido_details_search_dialog_empty_body:
		'Sobald Sie Bedingungen hinzufügen, erscheint hier die Struktur des aktuellen Filter-Entwurfs.',
	ido_details_search_dialog_empty_title: 'Noch keine Detailfilter konfiguriert',
	ido_details_search_dialog_reset: 'Zurücksetzen',
	ido_details_search_dialog_title: 'Detailsuche',
	ido_details_search_field_label: 'Feld',
	ido_details_search_field_values_error: 'Die Auswahlwerte konnten nicht geladen werden.',
	ido_details_search_fields_empty: 'Für diese Instanz sind keine Detailsuch-Felder verfügbar.',
	ido_details_search_fields_error: 'Die verfügbaren Detailsuch-Felder konnten nicht geladen werden.',
	ido_details_search_fields_loading: 'Detailsuch-Felder werden geladen...',
	ido_details_search_geo_radius_country_label: 'Land',
	ido_details_search_geo_radius_km_label: 'Umkreis in km',
	ido_details_search_geo_radius_postal_code_label: 'Postleitzahl',
	ido_details_search_group_empty_state: 'Fügen Sie eine Bedingung oder Untergruppe hinzu.',
	ido_details_search_location_contact_person: 'Ansprechpartner',
	ido_details_search_location_master_data: 'Stammdaten',
	ido_details_search_logical_operator_and: 'UND',
	ido_details_search_logical_operator_or: 'ODER',
	ido_details_search_nested_group_label: 'Untergruppe',
	ido_details_search_operation_doesContain: 'enthält',
	ido_details_search_operation_doesNotContain: 'enthält nicht',
	ido_details_search_operation_is: 'ist',
	ido_details_search_operation_isAfter: 'ist nach',
	ido_details_search_operation_isAll: 'enthält alle',
	ido_details_search_operation_isAny: 'enthält eines von',
	ido_details_search_operation_isBefore: 'ist vor',
	ido_details_search_operation_isBeginningWith: 'beginnt mit',
	ido_details_search_operation_isEmpty: 'ist leer',
	ido_details_search_operation_isEndingWith: 'endet mit',
	ido_details_search_operation_isGreaterThan: 'ist größer als',
	ido_details_search_operation_isInRadiusSearch: 'liegt im Umkreis',
	ido_details_search_operation_isInTheLast: 'liegt in den letzten',
	ido_details_search_operation_isInTheNext: 'liegt in den nächsten',
	ido_details_search_operation_isInTheRange: 'liegt im Bereich',
	ido_details_search_operation_isLessThan: 'ist kleiner als',
	ido_details_search_operation_isNot: 'ist nicht',
	ido_details_search_operation_isNotAll: 'enthält nicht alle',
	ido_details_search_operation_isNotAny: 'enthält keines von',
	ido_details_search_operation_isNotBeginningWith: 'beginnt nicht mit',
	ido_details_search_operation_isNotEmpty: 'ist nicht leer',
	ido_details_search_operation_isNotEndingWith: 'endet nicht mit',
	ido_details_search_operation_isNotInTheLast: 'liegt nicht in den letzten',
	ido_details_search_operation_isNotInTheNext: 'liegt nicht in den nächsten',
	ido_details_search_operation_isNotInTheRange: 'liegt nicht im Bereich',
	ido_details_search_operation_isNotTrue: 'ist nicht wahr',
	ido_details_search_operation_isTrue: 'ist wahr',
	ido_details_search_operation_label: 'Operation',
	ido_details_search_remove_condition: 'Bedingung entfernen',
	ido_details_search_remove_group: 'Gruppe entfernen',
	ido_details_search_root_group_label: 'Hauptgruppe',
	ido_details_search_summary_chip_active: '{count} Detailfilter aktiv',
	ido_details_search_summary_chip_dirty: 'Entwurf geändert',
	ido_details_search_summary_chip_empty: 'Detailsuche',
	ido_details_search_summary_chip_more: 'weitere',
	ido_details_search_terms_label: 'Suchwert',
	ido_details_search_terms_not_required: 'Für diese Operation ist kein Suchwert erforderlich.',
	ido_details_search_terms_unsupported: 'Dieser Feldtyp wird im nächsten Slice ergänzt.',
	ido_details_search_toolbar_button_active_tooltip: 'Detailsuche öffnen ({count} aktive Bedingungen)',
	ido_details_search_toolbar_button_disabled_tooltip: 'Detailsuche ist in diesem Kontext noch nicht verfügbar',
	ido_details_search_toolbar_button_tooltip: 'Detailsuche öffnen',
	ido_dirty_field_dialog_apply_remote: 'Serverwert übernehmen',
	ido_dirty_field_dialog_empty_value: '(leer)',
	ido_dirty_field_dialog_field_summary: '{fieldName}: Serverwert "{remoteValue}", Ihre Änderung "{localValue}"',
	ido_dirty_field_dialog_field_summary_with_change_metadata:
		'{fieldName}: wurde am {changedAt} durch den Benutzer {fullUsername} geändert. Serverwert "{remoteValue}", Ihre Änderung "{localValue}"',
	ido_dirty_field_dialog_keep_local: 'Meine Änderung behalten',
	ido_dirty_field_dialog_message:
		'Die Akte „{recordTitle}“ wurde an anderer Stelle geändert.\n\n{conflicts}\n\nMöchten Sie den Serverwert übernehmen oder Ihre Änderung behalten?',
	ido_dirty_field_dialog_title: 'Konkurrierende Änderung',
	ido_document_column_category: 'Kategorie',
	ido_document_column_date: 'Datum',
	ido_document_column_information: 'Bezeichnung',
	ido_document_column_postbox: 'Ablage',
	ido_document_export_title: 'Dokumente',
	ido_document_filter_categories_label: 'Kategorien',
	ido_document_filter_categories_selected: "{'{'}0{'}'} Kategorien",
	ido_document_filter_uncategorised: 'Unkategorisiert',
	ido_document_load_error: 'Die Dokumente konnten nicht geladen werden.',
	ido_document_loading: 'Dokumente werden geladen...',
	ido_document_no_results: 'Keine Dokumente gefunden.',
	ido_document_open_fallback_label: 'Dokument öffnen',
	ido_document_page_of: "von {'{'}totalPages{'}'}",
	ido_document_page_report: 'Anzeige Eintrag {first} - {last} von {totalRecords}',
	ido_document_save_list_context: 'Suche und Kategorie-Filter dieser Dokumentenliste werden mitgespeichert.',
	ido_document_save_list_name_placeholder: 'z. B. Rechnungen 2026',
	ido_document_save_list_tooltip: 'Liste anlegen',
	ido_document_search_placeholder: 'Dokumente durchsuchen',
	ido_export_complete_combined_csv: 'kompletter Stammdaten- und Ansprechpartnerexport als CSV',
	ido_export_complete_contact_person_csv: 'kompletter Ansprechpartnerexport als CSV',
	ido_export_complete_csv: 'kompletter Stammdatenexport als CSV',
	ido_export_complete_note_archive_csv: 'Hinweis- und Archivexport als CSV',
	ido_export_section_complete: 'Komplettexport',
	ido_export_section_page: 'Seitenexport',
	ido_history_filter_deselect_all: 'Alle abwählen',
	ido_history_filter_hub: 'Filter',
	ido_history_filter_select_all: 'Alle auswählen',
	ido_history_module_filter: 'Module',
	ido_history_open_view: 'Offen',
	ido_history_search_clear: 'Sucheingabe löschen',
	ido_history_time_range_all: 'Alle',
	ido_history_time_range_filter: 'Zeitraum',
	ido_history_time_range_four_weeks: '4 Wochen',
	ido_history_time_range_seven_days: '7 Tage',
	ido_history_time_range_today: 'Tag',
	ido_history_user_filter: 'Benutzer',
	ido_history_user_filter_groups: 'Gruppen',
	ido_idos_count: '{count} Akten',
	ido_idos_label: 'Akten',
	ido_idos_show_all: 'Alle Akten anzeigen',
	ido_instance_filter_clear_tooltip: 'Filter löschen',
	ido_instance_filter_placeholder: 'Aktentypen filtern...',
	ido_instance_picker_empty: 'Keine Aktentypen verfügbar',
	ido_instance_sidebar_resize: 'Breite der Aktentypen-Seitenleiste anpassen',
	ido_instance_sidebar_resize_reset_hint: 'Doppelklick zum Zurücksetzen',
	ido_list_entries_loading: 'Akteneinträge werden geladen...',
	ido_list_global_search: 'Alle Instanzen durchsuchen',
	ido_list_hidden_tabs_dialog_later_button: 'Später erinnern',
	ido_list_hidden_tabs_dialog_message:
		'Wenn Sie eine globale Suche durchführen, werden alle geöffneten Instanz-Tabs vorübergehend ausgeblendet. Sie werden wieder angezeigt, wenn Sie die Suche löschen. So bleibt Ihr Arbeitsbereich bei globalen Suchen sauber.',
	ido_list_hidden_tabs_dialog_ok_button: 'OK, verstanden',
	ido_list_hidden_tabs_dialog_title: 'Informationen zu ausgeblendeten Tabs',
	ido_list_hidden_tabs_indicator: 'ausgeblendete Tabs',
	ido_list_hidden_tabs_tooltip: 'Diese Tabs werden wieder angezeigt, wenn Sie die globale Suche leeren.',
	ido_list_instance: 'Instanz',
	ido_list_instance_search_mode: 'Instanzsuche aktivieren',
	ido_list_instance_search_mode_action: 'Nur gewählte Instanz durchsuchen',
	ido_list_instance_search_mode_tooltip: 'Wechselt zurück zur Instanzsuche',
	ido_list_instances_all: 'Alle Instanzen durchsuchen',
	ido_list_instances_all_action: 'Alle Instanzen durchsuchen',
	ido_list_instances_all_tooltip: 'Wechselt in den globalen Suchmodus (alle Instanzen)',
	ido_list_loading: 'Akten werden geladen...',
	ido_list_mobile_next_page_tooltip: 'Nächste Seite',
	ido_list_mobile_page_input_label: 'Seite',
	ido_list_mobile_page_status: 'Seite {page} von {pageCount}',
	ido_list_mobile_previous_page_tooltip: 'Vorherige Seite',
	ido_list_mobile_rows_per_page_label: 'Zeilen',
	ido_list_no_lists_available: 'Keine Listen verfügbar',
	ido_list_page_of: "von {'{'}totalPages{'}'}",
	ido_list_page_report: 'Anzeige Eintrag {first} - {last} von {totalRecords}',
	ido_list_select_instance: 'Akte auswählen',
	ido_list_select_instance_to_browse: 'Aktentyp auswählen zum Durchsuchen',
	ido_list_shared_query: 'Geteilte Abfrage',
	ido_list_table_height: 'Tabellenhöhe',
	ido_lists: 'Listen',
	ido_mail_attachment_column_contact: 'Kontakt',
	ido_mail_attachment_column_date: 'Datum',
	ido_mail_attachment_column_filename: 'Dateiname',
	ido_mail_attachment_column_mailbox: 'Postfach',
	ido_mail_attachment_load_error: 'Die E-Mail-Anhänge konnten nicht geladen werden.',
	ido_mail_attachment_loading: 'E-Mail-Anhänge werden geladen...',
	ido_mail_attachment_no_results: 'Keine E-Mail-Anhänge gefunden.',
	ido_mail_attachment_open_mail_fallback_label: 'E-Mail öffnen',
	ido_mail_attachment_page_of: "von {'{'}totalPages{'}'}",
	ido_mail_attachment_page_report: 'Anzeige Eintrag {first} - {last} von {totalRecords}',
	ido_mail_attachment_search_placeholder: 'E-Mail-Anhänge durchsuchen',
	ido_no_results: 'Keine Ergebnisse',
	ido_print_choose_data_source: 'Daten wählen…',
	ido_print_failed: 'Drucken fehlgeschlagen',
	ido_print_no_access: 'Kein Zugriff auf diese Vorlage',
	ido_print_search_placeholder: 'Druckvorlagen durchsuchen',
	ido_relations_empty_message: 'Für diese Akte sind keine Beziehungen vorhanden.',
	ido_relations_empty_title: 'Keine Beziehungen',
	ido_relations_history_invalid: 'Die Beziehungshistorie konnte nicht geladen werden.',
	ido_relations_history_title: 'Beziehungshistorie',
	ido_relations_instance_empty_title: 'Keine Einträge in diesem Aktentyp',
	ido_relations_load_more: 'Mehr laden',
	ido_relations_loaded_progress: '{loaded} von {total}',
	ido_relations_loading: 'Beziehungen werden geladen...',
	ido_relations_page_of: "von {'{'}totalPages{'}'}",
	ido_relations_page_report: 'Anzeige Eintrag {first} - {last} von {totalRecords}',
	ido_save_error_message: 'Die Akte konnte nicht gespeichert werden.',
	ido_save_stale_data_message:
		'Die Akte wurde zwischenzeitlich an anderer Stelle geändert. Bitte prüfen Sie die aktuellen Werte und speichern Sie erneut.',
	ido_save_stale_data_ok_label: 'OK',
	ido_save_stale_data_title: 'Akte wurde geändert',
	ido_send_message: 'Nachricht senden',
	ido_shared_query_save_as_context: 'Die Bedingungen deiner aktuellen Detailsuche werden mitgespeichert.',
	ido_shared_query_save_as_dialog_title: 'Detailsuche als Liste speichern',
	ido_shared_query_save_as_disabled_tooltip: 'Es gibt keinen Detailsuch-Entwurf zum Speichern',
	ido_shared_query_save_as_field_label: 'Listenname',
	ido_shared_query_save_as_name_placeholder: 'z. B. Offene Vorgänge – Nord',
	ido_shared_query_save_as_tooltip: 'Aktuellen Detailsuch-Entwurf als Liste speichern',
	ido_shared_query_save_error: 'Die Liste konnte nicht gespeichert werden.',
	ido_shared_query_save_success: 'Die Liste "{name}" wurde gespeichert.',
	ido_start_timer: 'Timer starten',
	ido_toolbar_visibility_tooltip: 'Sichtbarkeit der Spalten',
	ido_unknown_instance: 'Unbekannte Instanz',
	ido_validation_required_field: 'Pflichtfeld.',
	input_placeholder_search_value: 'Suchbegriff',
	loading: 'Laden...',
	no_shared_queries_available: 'Keine Listen vorhanden',
	no_shared_queries_found: 'Keine Listen gefunden',
	no_shared_queries_placeholder: 'Keine gespeicherten Listen vorhanden',
	search_all_instances_placeholder: 'Über alle Akten suchen...',
	search_in_instance_placeholder: 'Suche in der Instanz...',
	search_in_specific_instance_placeholder: 'In {name} suchen...',
	search_shared_queries_placeholder: 'Listen durchsuchen...',
	search_term: 'Suchbegriff',
	select_an_instance_to_view_results: 'Instanz auswählen, um Ergebnisse zu sehen',

	select_instance_to_browse: 'Instanz auswählen zum Durchsuchen',
	select_instance_to_view_details:
		'Wählen Sie eine Instanz aus der linken Liste aus, um die detaillierten Ergebnisse zu sehen.',
	select_instance_to_view_results: 'Instanz auswählen, um Ergebnisse zu sehen',
	shared_queries_empty_hint: 'Erstellen Sie Listen, um sie hier zu sehen',
	shared_queries_label: 'Listen',
	shared_queries_placeholder: 'Liste auswählen...',
	shared_query_readonly_tooltip: 'Aktuelle Liste (nicht änderbar)',
};
